<template>
  <div class="balance-panel shadow-1">
    <div class="gap-row-2xs">
      <div class="qrw-label-lg bold w-100 v1-grey-10-color">
        {{ $t("current_balance.title") }}
      </div>
      <div class="qrw-heading-xl bold w-100" :class="{
        'green-5-color': currentBalance >= 0,
        'red-4-color': currentBalance < 0
      }">
        $ {{ currentBalance.toFixed(2) }}
      </div>
    </div>
    <BaseDivider color="v1-grey-4" />
    <div class="gap-column-1xs">
      <BaseUnitInput
        :placeholder="$t('current_balance.amount_ph')"
        type="number"
        unitPlaceholder="$"
        v-model.number="topup_amount"
        fullWidth
      />
      <BaseButton
        icon="download-bold"
        bold
        variant="primary"
        color="green-5"
        class="w-100"
        :disabled="!topup_amount || topup_amount < 0"
        @click="generateForm"
        size="md"
      >
        {{ $t("current_balance.btn_topup") }}
      </BaseButton>
    </div>

    <form
      method="POST"
      action="https://www.liqpay.ua/api/3/checkout"
      accept-charset="utf-8"
      ref="depositForm"
      style="display: none;"
    >
      <input type="hidden" name="data" :value="form.data" />
      <input type="hidden" name="signature" :value="form.signature" />
    </form>
  </div>
</template>

<script>
import BillingAPI from "@/api/billing";

export default {
  data() {
    return {
      topup_amount: null,

      form: {},
    };
  },
  methods: {
    generateForm() {
      BillingAPI.getDepositForm(
        this.topup_amount,
        this.$store.state.cafe.name
      ).then((data) => {
        this.form = data.form;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.depositForm.submit();
          }, 250);
        });
      });
    },
  },
  computed: {
    currentBalance() {
      return this.$store.state.billing_account.balance;
    },
  },
};
</script>

<style scoped>
.balance-panel {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  background: var(--v1-grey-2-color);
  padding: 16px;
  border-radius: 8px;
}
</styles>